import { render } from "./TitleAndHeader.vue?vue&type=template&id=7e366596&scoped=true&ts=true"
import script from "./TitleAndHeader.vue?vue&type=script&lang=ts"
export * from "./TitleAndHeader.vue?vue&type=script&lang=ts"

import "./TitleAndHeader.vue?vue&type=style&index=0&id=7e366596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e366596"]])

export default __exports__